import { Component, ElementRef, Input, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@spartacus/core';
import { ColumnConfig } from 'material-dynamic-table';
import { take } from 'rxjs';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';

@Component({
  selector: 'app-saved-carts-list-desc-cell',
  templateUrl: './saved-carts-list-desc-cell.component.html',
  styleUrls: ['./saved-carts-list-desc-cell.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [TranslatePipe],
})
export class SavedCartsListDescCellComponent implements OnInit {
  @Input() column: ColumnConfig;
  @Input() row: any;

  constructor(
    protected modalService: StandardModalService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef
  ) {}

  ngOnInit() {}

  openError(code: any) {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.OPEN_ERROR, this.el, this.vcr, { cartId: code })
      ?.pipe(take(1))
      .subscribe();
  }
}
